import { useQuery } from "react-query";
import { getAllAcquisition } from "../../../../../actions/Utilities/Acquisition";

export default function useGetAcquisition() {
  return useQuery("getAcquisition", getAllAcquisition, {
    refetchOnWindowFocus: false,
  });
}
